import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-pitch" data-id="element-28" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-29" data-mp="vtxnwgdrvq02">
        <h2 id="bonos" className="font-display text-4xl font-normal uppercase leading-none sm:text-5xl" data-id="element-30" data-mp="qu2vg8ecmscw">
          <span className="rounded-lg bg-gold px-2 py-0.5 text-pitch" data-id="element-31" data-mp="14s9o9a4fy25p">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-pitch/80" data-id="element-32" data-mp="zsexr7okvel6">
          Y además recibes 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-field" data-id="element-33" data-mp="19jrdj0x3qeau">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="1nl3r55osi3tk">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-pitch bg-cream text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="1jji9l71b91d1" data-mpi={i}>
              <span className="bg-pitch px-2.5 py-1 font-sub text-sm font-extrabold text-gold" data-id="element-36" data-mp="2k1a1a5tipll">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="ck1ytbmghxx6">
                <h3 className="font-sub text-sm font-extrabold leading-tight text-field" data-id="element-38" data-mp="chpguygp7nk4">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-pitch/80 sm:text-sm" data-id="element-39" data-mp="lblprbkur3hl">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-pitch/80" data-id="element-40" data-mp="q9vo1v1vik7f">
                  Valor:{' '}
                  <span className="text-red-700 line-through decoration-2" data-id="element-41" data-mp="vc4h0reqxm9j">
                    {bono.value}
                  </span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-gold bg-pitch px-3 py-2.5 leading-tight" data-id="element-42" data-mp="aj4iceb5kucz">
          <p className="font-sub text-base font-extrabold text-white" data-id="element-43" data-mp="kb1xfw5a86gz">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-white/80 line-through decoration-red-500 decoration-2" data-id="element-44" data-mp="fjsbp6mutnad">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="mt-1 font-display text-lg uppercase text-gold" data-id="element-45" data-mp="t9vs3gz1ymrw">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}